new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder')
      ? localStorage.getItem('listOrder')
      : (localStorage.setItem('listOrder', 2), 2),
    listExMobile: localStorage.getItem('listOrderMobile')
      ? localStorage.getItem('listOrderMobile')
      : (localStorage.setItem('listOrderMobile', 0), 0)
  },
  methods: {
    buySize() {
      const filterSize = document.querySelector(".product-filter__item--size:not(.product-filter__item--color)");
      if (filterSize) {
        const cloneFilterSize = filterSize;
        const elementDest = document.querySelector(".buy-sizes");
        if (cloneFilterSize && elementDest) {
          elementDest.append(cloneFilterSize.cloneNode(true));
        }
      } else {
        document.querySelector('.product-list-size').style.display = 'none';
      }
    },
    dropdownFilter() {
      const elementDest = document.querySelector(".product-list__section--filter.dropdown.hidden-filter");
      const dropdownFilter = document.querySelector(".product-list__section--filter.dropdown:not(.hidden-filter)");

      if (elementDest && dropdownFilter) {
        // Pegar .product-filter.product-filter--category que é uma tag nav e converter para li
        const categoryFilter = elementDest.querySelector(".product-filter.product-filter--category");
        if (categoryFilter && categoryFilter.tagName === 'NAV') {
          const liCategory = document.createElement('li');
          liCategory.className = categoryFilter.className;
          liCategory.innerHTML = categoryFilter.innerHTML;

          // Dentro do liCategory pode haver um ul, e dentro dos li desse ul pode haver outro ul aninhado
          // Remover os ul aninhados e deixar os li no mesmo nível, mas ainda dentro do .product-filter--category
          const mainUl = liCategory.querySelector('ul');
          if (mainUl) {
            // Processar recursivamente para achatar todos os ul aninhados
            function flattenNestedUls(ulElement) {
              const directLiChildren = Array.from(ulElement.children).filter(child => child.tagName === 'LI');
              directLiChildren.forEach(li => {
                // Verificar se o li tem um ul como filho direto
                const nestedUl = Array.from(li.children).find(child => child.tagName === 'UL');
                if (nestedUl) {
                  const nestedLi = Array.from(nestedUl.children).filter(child => child.tagName === 'LI');
                  // Adicionar os li aninhados no mesmo nível do li pai, dentro do ulElement
                  nestedLi.forEach(nestedLiItem => {
                    ulElement.insertBefore(nestedLiItem, li.nextSibling);
                  });
                  // Remover o ul aninhado do li
                  nestedUl.remove();
                  // Processar recursivamente caso haja mais níveis
                  flattenNestedUls(ulElement);
                }
              });
            }
            flattenNestedUls(mainUl);
          }

          // Fazer append do categoryFilter convertido no dropdown antes de substituir
          dropdownFilter.append(liCategory.cloneNode(true));
          categoryFilter.replaceWith(liCategory);
        }

        // Pegar todas as tags li dentro de .product-filter.product-filter--filters .product-filter__menu
        const filtersMenu = elementDest.querySelector(".product-filter.product-filter--filters .product-filter__menu");
        if (filtersMenu) {
          const listItems = filtersMenu.querySelectorAll('li.product-filter__item');
          listItems.forEach(li => {
            dropdownFilter.append(li.cloneNode(true));
          });
        }
      }
    },
    filterPrice() {
      //chamadas para o filtro de preço
      function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#D4D4D4', '#1D1D1B', controlSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
        }
      }

      function controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#D4D4D4', '#1D1D1B', controlSlider);
        setToggleAccessible(toInput);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
        }
      }

      function controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#D4D4D4', '#1D1D1B', toSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromInput.value = from;
        }
      }

      function controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#D4D4D4', '#1D1D1B', toSlider);
        setToggleAccessible(toSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
          toSlider.value = from;
        }
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      const fromSlider = document.querySelector('#fromSlider');
      const toSlider = document.querySelector('#toSlider');
      const fromInput = document.querySelector('#fromInput');
      const toInput = document.querySelector('#toInput');
      let url = window.location.href;

      if (url.includes('?lp=')) {
        const params = new URLSearchParams(window.location.search)
        const firstParams = params.get('lp');
        const secondParams = params.get('hp');
        fromInput.value = firstParams;
        toInput.value = secondParams;
        fromSlider.setAttribute('value', firstParams);
        toSlider.setAttribute('value', secondParams);
        fillSlider(fromSlider, toSlider, '#D4D4D4', '#1D1D1B', toSlider);
      } else {
        fillSlider(fromSlider, toSlider, '#D4D4D4', '#1D1D1B', toSlider);
        setToggleAccessible(toSlider);
      }

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

      function handleSliderRelease() {
        let from = $('#fromInput').val();
        let to = $('#toInput').val();
        window.location = `?lp=${from}&hp=${to}`;
      }

      $(fromSlider).mouseup(handleSliderRelease);
      $(fromSlider).on('touchend', handleSliderRelease);

      $(toSlider).mouseup(handleSliderRelease);
      $(toSlider).on('touchend', handleSliderRelease);
    },
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  mounted() {
    this.buySize();
    this.dropdownFilter();
  },
});

document.addEventListener('DOMContentLoaded', () => {

  var bannerHomeFull = $('.product-list__banner__list');

    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 300,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

  waitForElementToExist('.product-ratings').then(element => {
    const productRatings = element.querySelector('.product-ratings-list');
    if (productRatings) {
      $('.product-ratings-list').slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        autoplay: false,
        autoplaySpeed: 2000,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 100,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
              dots: false,
              adaptiveHeight: true,
              arrows: true,
              appendArrows: $(".product-ratings .group-arrow"),
            }
          },
        ]
      });

      $('.product-ratings-list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        Blazy({
          selector: '.lazy-img',
          successClass: 'loaded-img',
          success: function (element) {
            setTimeout(function () {
              var parent = element.previousSibling;
              try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
            }, 200);
          }
        });
      });
    }
  });

  const thirdVitrine = document.querySelector('#product_list3');
  if (thirdVitrine) {
    $('#product_list3').slick({
      arrows: true,
      dots: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 700,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4,
          }
        }
      ]
    });

    $('#product_list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
      Blazy({
        selector: '.lazy-img',
        successClass: 'loaded-img',
        success: function (element) {
          setTimeout(function () {
            var parent = element.previousSibling;
            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
          }, 200);
        }
      });
    });
  }
})